import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

// Friendly, on-brand empty state: a soft gradient "spot" illustration with a
// duotone icon, a short line of copy and a clear next step.
export const PortalEmpty = ({
  icon: Icon,
  title,
  text,
  ctaLabel,
  ctaTo,
  secondaryLabel,
  secondaryTo,
  testId,
  className = "",
}) => (
  <div
    data-testid={testId}
    className={`flex flex-col items-center rounded-2xl border border-dashed border-slate-200 bg-white/60 px-6 py-12 text-center ${className}`}
  >
    <div className="relative flex h-20 w-20 items-center justify-center">
      <div className="absolute inset-0 rotate-6 rounded-[26px] bg-gradient-to-br from-teal-100 to-cyan-100" />
      <div className="absolute inset-0 -rotate-6 rounded-[26px] bg-gradient-to-tr from-teal-50 to-cyan-50" />
      <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-amber-300" />
      <span className="absolute -left-1 bottom-1 h-2 w-2 rounded-full bg-teal-400" />
      {Icon && <Icon size={34} weight="duotone" className="relative text-teal-600" />}
    </div>
    <h3 className="mt-5 text-base font-semibold text-slate-900">{title}</h3>
    {text && (
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-500">{text}</p>
    )}
    <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
      {ctaTo && (
        <Link
          to={ctaTo}
          data-testid={testId ? `${testId}-cta` : undefined}
          className="inline-flex items-center gap-2 rounded-full bg-[#c39e6d] px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-[#a9855a]"
        >
          {ctaLabel} <ArrowRight size={15} weight="bold" />
        </Link>
      )}
      {secondaryTo && (
        <Link
          to={secondaryTo}
          data-testid={testId ? `${testId}-secondary` : undefined}
          className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-semibold text-slate-600 transition-colors duration-150 hover:bg-slate-50 hover:text-slate-900"
        >
          {secondaryLabel}
        </Link>
      )}
    </div>
  </div>
);
